<template>
  <div class="bg">
    <!-- 操作栏 -->
    <div class="top_search_part">
      <div class="search_box">
        <div class="goBackBox" @click="goBack">
          <img class="goBackIcon" src="@/assets/backIcon.svg" />
          <span class="goBackTitle">{{$t('message.backText')}}</span>
        </div>
        <div class="search_item">{{$t('message.noEnterContainersNum')}}：{{noEnterContainersNum}}</div>
      </div>
    </div>
    <!-- 操作栏 -->
    <div class="content">
      <div class="leftFooter">
        <div class="searchTopBox">
          <el-input class="searchCodingInput" :placeholder="$t('message.containerOrderNumber')" v-model="containerCoding"></el-input>
          <img class="queryIcon" src="@/assets/queryIcon_blue.svg" @click="searchCoding" />
        </div>
        <div class="containerCodingBox">
          <el-radio-group v-model="selCoding" @change="codingChange">
            <label class="containerBox" v-for="(coding, index) in codingList" :key="index">
              <el-radio :label="coding" style="display: none;"></el-radio>
              <div>{{coding.JZXNUM}}</div>
            </label>
          </el-radio-group>
        </div>
      </div>
      <div class="rightFooter" v-if="showCreate">
        <div class="supplementBox">
          <div class="newBtn" @click="createOrder">
            <img class="addNewIcon" src="@/assets/addIcon.svg" />
            <span class="addNewText">{{$t('message.createContainerOrder')}}</span>
          </div>
        </div>
        <div class="tableBox2">
          <el-table id="orderList" :data="orderList" width="100%">
            <el-table-column :label="$t('message.customTableTitle1')" prop="index" width="85"></el-table-column>
            <el-table-column :label="$t('message.arrivePort')" prop="JZXCITY" min-width="100"></el-table-column>
            <el-table-column :label="$t('message.orderTableTitle1')" prop="ORDERNUM" min-width="210"></el-table-column>
            <el-table-column :label="$t('message.orderRemarkTitle')" prop="REMARK" width="150"></el-table-column>
            <el-table-column :label="$t('message.orderTableTitle2')" width="120">
              <template slot-scope="scope">
                <a :href="scope.row.imgSrc" :download="scope.row.TXM">
                  <img class="barCodeImg" :src="scope.row.imgSrc" />
                  <!-- <el-image class="barCodeImg" :src="scope.row.imgSrc" :preview-src-list="[scope.row.imgSrc]"></el-image> -->
                </a>
              </template>
            </el-table-column>
            <el-table-column :label="$t('message.addresseeAddressTitle')" prop="SJDZ" min-width="150"></el-table-column>
            <el-table-column :label="$t('message.addresseeCompanyTitle')" prop="SJGS" min-width="150"></el-table-column>
            <el-table-column :label="$t('message.addresseeNameTitle')" prop="SJR" width="140"></el-table-column>
            <el-table-column :label="$t('message.addresseePhoneTitle')" prop="SJRPHONE" width="150"></el-table-column>
            <el-table-column :label="$t('message.orderTableTitle10')" prop="status" width="120"></el-table-column>
            <el-table-column :label="$t('message.orderTableTitle11')" prop="addTime" min-width="120"></el-table-column>
            <el-table-column :label="$t('message.orderTableTitle7')" prop="WPSL" width="130"></el-table-column>
            <el-table-column :label="$t('message.orderTableTitle8')" prop="WPZL" width="130"></el-table-column>
            <el-table-column :label="$t('message.orderTableTitle9')" prop="WPTJ" width="130"></el-table-column>
            <el-table-column :label="$t('message.orderTableTitle4')" prop="JJGS" min-width="150"></el-table-column>
            <el-table-column :label="$t('message.orderTableTitle5')" prop="JJR" width="140"></el-table-column>
            <el-table-column :label="$t('message.orderTableTitle6')" prop="JJRPHONE" width="150"></el-table-column>
            <el-table-column :label="$t('message.customTableTitle5')" width="200">
              <template slot-scope="scope">
                <div class="btnBox">
                  <a target="_blank" :href="url + '/pdf/WlOrder?ORDERNUM=' + scope.row.ORDERNUM">pdf</a>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <el-dialog :title="$t('message.createContainerOrder')" :visible.sync="showCreateOrder" destroy-on-close :close-on-click-modal="false" center>
      <div class="addBox">
        <div class="addLine">
          <span class="addItemTitle">{{$t('message.containerOrderNumber')}}:</span>
          <el-input :value="selCoding.JZXNUM" disabled></el-input>
        </div>
        <div class="addLine">
          <span class="addItemTitle">{{$t('message.containerGoodsModel')}}:</span>
          <el-input disabled :value="selCoding.JZXSIZE"></el-input>
        </div>
        <div class="addLine">
          <span class="addItemTitle">{{$t('message.containerOrderCity')}}:</span>
          <el-select v-model="selCoding.CITY">
            <el-option v-for="item in cityOptions" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </div>
        <div class="addLine">
          <span class="addItemTitle">{{$t('message.containerJOBNO')}}:</span>
          <el-input v-model="selCoding.JOBNO" :disabled="!JOBNOCanInput" :placeholder="$t('message.placeholder')"></el-input>
        </div>
        <div class="addLine">
          <span class="addItemTitle">{{$t('message.containerStripping')}}:</span>
          <el-date-picker v-model="arrivalDate" :editable="false" :clearable="false" value-format="yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm" type="datetime"></el-date-picker>
        </div>
        <div class="addLine">
          <span class="addItemTitle">{{$t('message.containerOrderCustomerID')}}:</span>
          <el-select v-model="customerSel" :filterable="isAdmin" :placeholder="$t('message.exportDatePlaceholder')">
            <el-option v-for="item in customerLsit" :key="item.value" :label="item.label" :value="item.label + ',' + item.value">
            </el-option>
          </el-select>
        </div>
        <div class="addLine">
          <span class="addItemTitle">{{$t('message.containerOrderCustomer')}}:</span>
          <el-input v-model="containerCustomer" :placeholder="$t('message.placeholder')"></el-input>
        </div>
        <div class="addLine">
          <span class="addItemTitle">{{$t('message.containerOrderNum')}}:</span>
          <el-input v-model="selCoding.SHULIANG" :placeholder="$t('message.placeholder')"></el-input>
        </div>
        <div class="addLine">
          <span class="addItemTitle">{{$t('message.containerOrderVolume')}}:</span>
          <el-input v-model="selCoding.TIJI" :placeholder="$t('message.placeholder')"></el-input>
        </div>
        <div class="addLine">
          <span class="addItemTitle">{{$t('message.containerOrderWeight')}}:</span>
          <el-input v-model="selCoding.ZHONGLIANG" :placeholder="$t('message.placeholder')"></el-input>
        </div>
        <div class="addLine">
          <span class="addItemTitle">{{$t('message.containerOrderRemark')}}:</span>
          <el-input v-model="remark" :placeholder="$t('message.placeholder')"></el-input>
        </div>
        <div class="addLine">
          <span class="addItemTitle">{{$t('message.containerOrderAttacherFile')}}:</span>
          <el-upload :action="uploadFile()" :on-success="handleSuccess" class="uploadBox" :on-remove="handleRemove" :file-list="attacherFile">
            <el-button size="small" type="primary">{{$t('message.addFileText')}}</el-button>
          </el-upload>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showCreateOrder = false">{{$t('message.cancleText')}}</el-button>
        <el-button type="primary" @click="addNewConfirm">{{$t('message.confirmText')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { noEnterContain, containerGetOrder, imgSrc, uploadImg, setContainerOrder, HTTPS, getCustomer } from '@/api/getData.js'
  export default {
    name: 'noEnterContain',
    data () {
      return {
        noEnterContainersNum: 0,
        containerCoding: '',
        codingList: [],
        selCoding: {},
        isAdmin: false,
        JOBNOCanInput: false, // JHSS 工作号是否可输入
        orderList: [],
        showCreateOrder: false,
        cityOptions: ['東京', '大阪'],
        // cityVal: '',
        arrivalDate: '',
        customerLsit: [], // 客户列表
        customerSel: '', // 客户选择列表
        containerCustomer: '',
        // containerNumber: '',
        // containerVolume: '',
        // containerWeight: '',
        remark: '',
        attacherFile: [],
      }
    },
    created() {
      this.noEnterContain()
      if (!this.$store.state.JHSS.personalUserid.includes('admin')) {
        this.isAdmin = false
        this.customerLsit = [{
          label: this.$store.state.JHSS.personalAccount + '——' + this.$store.state.JHSS.personalCompany,
          value: this.$store.state.JHSS.personalUserid
        }]
      } else {
        this.isAdmin = true
        this.getCustomer()
      }
    },
    methods: {
      goBack () {
        this.$router.go(-1)
      },
      // 查询客户列表
      async getCustomer () {
        let res = await getCustomer({ IFQUERY: '1' })
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
          return
        } else {
          // console.log(res.data.dt)
          this.customerLsit = res.data.dt.map(item => {
            return {
              label: item.USHOWNAME + '——' + item.GUDING1,
              value: item.USERID
            }
          })
        }
      },
      // 查询未录入集装箱信息
      async noEnterContain (param) {
        param = param || {}
        let res = await noEnterContain(param)
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
        } else {
          this.noEnterContainersNum = res.data.length
          this.codingList = res.data
        }
      },
      searchCoding () {
        let param = { JZXNUM: this.containerCoding }
        this.noEnterContain(param)
      },
      async codingChange (obj) {
        let param = { JZXNUM: obj.JZXNUM }
        let res = await containerGetOrder(param)
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
        } else {
          let index = 0
          let orderState2 = this.$t('message.orderState2')
          let orderState1 = this.$t('message.orderState1')
          let orderState0 = this.$t('message.orderState0')
          let orderState3 = this.$t('message.orderState3')
          this.orderList = res.data.map(item => {
            item.index = ++index
            item.imgSrc = imgSrc(item.TXM)
            // item.status = item.STATE === '2' ? orderState2 : (item.STATE === '1' ? orderState1 : orderState0)
            switch (item.STATE) {
              case '0':
                item.status = orderState0
                break
              case '1':
                item.status = orderState1
                break
              case '2':
                item.status = orderState2
                break
              default:
                item.status = orderState3
            }
            item.addTime = item.ADDTIME.replace(/T/g, ' ')
            return item
          })
        }
      },
      createOrder () {
        this.showCreateOrder = true
        // this.cityVal = ''
        this.JOBNOCanInput = this.isAdmin && !this.selCoding.JOBNO
        this.arrivalDate = ''
        this.customerSel = ''
        this.containerCustomer = ''
        // this.containerNumber = ''
        // this.containerVolume = ''
        // this.containerWeight = ''
        this.remark = ''
        this.attacherFile = []
      },
      handleSuccess (file, fileList) {
        // console.log('success', fileList)
        let list = this.attacherFile
        list.push({
          name: fileList.response.data.fileoldname,
          url: imgSrc(fileList.response.data.filename),
          FILENAME: fileList.response.data.filename,
          FILEOLDNAME: fileList.response.data.fileoldname,
        })
        this.attacherFile = list
      },
      handleRemove (file, fileList) {
        console.log('remove', fileList)
        if (this.newOrder === 0) {
          let list = []
          for (let i = 0; i < fileList.length; i++) {
            let obj = {
              name: fileList[i].response.data.fileoldname,
              url: imgSrc(fileList[i].response.data.filename),
              FILENAME: fileList[i].response.data.filename,
              FILEOLDNAME: fileList[i].response.data.fileoldname
            }
            list.push(obj)
          }
          this.attacherFile = list
        } else {
          this.attacherFile = fileList
        }
      },
      async addNewConfirm () {
        if (!this.arrivalDate) {
          this.$message(this.$t('message.containerStripping'))
        } else {
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          let param = {
            main: {
              ID: this.selCoding.ID,
              CITY: this.selCoding.CITY,
              JZXSIZE: this.selCoding.JZXSIZE,
              JZXNUM: this.selCoding.JZXNUM,
              DADATE: this.arrivalDate.split(' ')[0],
              DATIME: this.arrivalDate.split(' ')[1],
              CUSTOMERID: this.customerSel,
              KEREN: this.containerCustomer,
              SHULIANG: this.selCoding.SHULIANG,
              TIJI: this.selCoding.TIJI,
              ZHONGLIANG: this.selCoding.ZHONGLIANG,
              REMARK: this.remark
            },
            lst: this.attacherFile
          }
          param.main.EDITUSER = this.$store.state.JHSS.personalUserid
          param.main.GUDING2 = this.$store.state.JHSS.personalAccount
          let res = await setContainerOrder(param)
          loading.close()
          if (res.status !== 200) {
            this.$message.error('network error：' + res.status)
          } else if (res.data.result !== '1') {
            this.$message.error(res.data.message)
          } else {
            this.showCreateOrder = false
            this.searchCoding()
            this.selCoding = {}
          }
        }
      }
    },
    computed: {
      showCreate () {
        return JSON.stringify(this.selCoding) !== '{}'
      },
      uploadFile () {
        return uploadImg
      },
      url () {
        return HTTPS
      }
    }
  }
</script>

<style scoped>
.content {
  display: flex;
  align-items: stretch;
}
.leftFooter {
  flex-shrink: 0;
  width: 250px;
  border-right: 1px solid #DDDDDD;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
.searchTopBox {
  flex-shrink: 0;
  padding: 20px 10px;
  display: flex;
  align-items: center;
}
.searchCodingInput {
  flex-grow: 1;
}
.queryIcon {
  margin-left: 10px;
  flex-shrink: 0;
  width: 20px;
  height: 20px;
}
.containerCodingBox {
  flex-grow: 1;
  overflow-y: scroll;
}
.containerCodingBox::-webkit-scrollbar { width: 0 !important; }
.containerCodingBox{ /* -ms-overflow-style: none; */ -ms-overflow-x: unset; }
.containerCodingBox { overflow: -moz-scrollbars-none; }
/deep/ .el-radio-group {
  width: 100%;
}
.containerBox {
  display: block;
  width: 100%;
  height: 45px;
  text-align: center;
  font-size: 18px;
  line-height: 45px;
  color: #333333;
}
/deep/ .containerBox .is-checked + div {
  background: #0048FF;
  color: #FFFFFF;
}
.rightFooter {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  overflow-y: scroll;
}
.rightFooter::-webkit-scrollbar { width: 0 !important; }
.rightFooter{ /* -ms-overflow-style: none; */ -ms-overflow-x: unset; }
.rightFooter { overflow: -moz-scrollbars-none; }
.supplementBox {
  padding: 10px;
}
.tableBox2 {
  width: 100%;
  flex-grow: 1;
}

/* 订单弹窗 */
/deep/ .el-dialog__header {
  background: #0066FF;
}
/deep/ .el-dialog__title, /deep/ .el-dialog__headerbtn .el-dialog__close {
  color: #ffffff;
}
.addLine {
  display: flex;
  justify-content: flex-start;
  align-items: baseline;
  flex-wrap: nowrap;
  margin-top: 10px;
  min-height: 50px;
}
.addItemTitle {
  flex-shrink: 0;
  width: 200px;
  font-size: 18px;
  color: #333333;
  margin-right: 10px;
  text-align: right;
  word-break: keep-all;
}
.el-input {
  width: 45%;
}
/deep/ .el-input__inner {
  text-align: left;
}
.uploadBox {
  display: flex;
  align-items: baseline;
}
.dialog-footer {
  margin-top: 10px;
}
</style>
